"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var flatObj = function flatObj(targetObj) {
  var flatResult = {};

  var flatRecusive = function flatRecusive(obj) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (obj === undefined || obj === null) {
      return;
    } else if (Array.isArray(obj)) {
      flatResult["".concat(prefix)] = obj;
    } else if ((0, _typeof2["default"])(obj) === 'object') {
      Object.entries(obj).forEach(function (_ref) {
        var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        if ((0, _typeof2["default"])(value) === 'object') {
          flatRecusive(value, "".concat(prefix).concat(key, "."));
        } else {
          flatResult["".concat(prefix).concat(key)] = value;
        }
      });
    }
  };

  flatRecusive(targetObj);
  return flatResult;
};

var _default = flatObj;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wdXJlLWZ1bmN0aW9ucy9mbGF0LW9iai50cyJdLCJuYW1lcyI6WyJmbGF0T2JqIiwidGFyZ2V0T2JqIiwiZmxhdFJlc3VsdCIsImZsYXRSZWN1c2l2ZSIsIm9iaiIsInByZWZpeCIsInVuZGVmaW5lZCIsIkFycmF5IiwiaXNBcnJheSIsIk9iamVjdCIsImVudHJpZXMiLCJmb3JFYWNoIiwia2V5IiwidmFsdWUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7QUFBQSxJQUFNQSxPQUFPLEdBQUcsU0FBVkEsT0FBVSxDQUFBQyxTQUFTLEVBQUk7QUFDM0IsTUFBTUMsVUFBVSxHQUFHLEVBQW5COztBQUNBLE1BQU1DLFlBQVksR0FBRyxTQUFmQSxZQUFlLENBQUNDLEdBQUQsRUFBc0I7QUFBQSxRQUFoQkMsTUFBZ0IsdUVBQVAsRUFBTzs7QUFDekMsUUFBSUQsR0FBRyxLQUFLRSxTQUFSLElBQXFCRixHQUFHLEtBQUssSUFBakMsRUFBdUM7QUFDckM7QUFDRCxLQUZELE1BRU8sSUFBSUcsS0FBSyxDQUFDQyxPQUFOLENBQWNKLEdBQWQsQ0FBSixFQUF3QjtBQUM3QkYsTUFBQUEsVUFBVSxXQUFJRyxNQUFKLEVBQVYsR0FBMEJELEdBQTFCO0FBQ0QsS0FGTSxNQUVBLElBQUkseUJBQU9BLEdBQVAsTUFBZSxRQUFuQixFQUE2QjtBQUNsQ0ssTUFBQUEsTUFBTSxDQUFDQyxPQUFQLENBQWVOLEdBQWYsRUFBb0JPLE9BQXBCLENBQTRCLGdCQUFrQjtBQUFBO0FBQUEsWUFBaEJDLEdBQWdCO0FBQUEsWUFBWEMsS0FBVzs7QUFDNUMsWUFBSSx5QkFBT0EsS0FBUCxNQUFpQixRQUFyQixFQUErQjtBQUM3QlYsVUFBQUEsWUFBWSxDQUFDVSxLQUFELFlBQVdSLE1BQVgsU0FBb0JPLEdBQXBCLE9BQVo7QUFDRCxTQUZELE1BRU87QUFDTFYsVUFBQUEsVUFBVSxXQUFJRyxNQUFKLFNBQWFPLEdBQWIsRUFBVixHQUFnQ0MsS0FBaEM7QUFDRDtBQUNGLE9BTkQ7QUFPRDtBQUNGLEdBZEQ7O0FBZUFWLEVBQUFBLFlBQVksQ0FBQ0YsU0FBRCxDQUFaO0FBQ0EsU0FBT0MsVUFBUDtBQUNELENBbkJEOztlQXFCZUYsTyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IGZsYXRPYmogPSB0YXJnZXRPYmogPT4ge1xuICBjb25zdCBmbGF0UmVzdWx0ID0ge307XG4gIGNvbnN0IGZsYXRSZWN1c2l2ZSA9IChvYmosIHByZWZpeCA9ICcnKSA9PiB7XG4gICAgaWYgKG9iaiA9PT0gdW5kZWZpbmVkIHx8IG9iaiA9PT0gbnVsbCkge1xuICAgICAgcmV0dXJuO1xuICAgIH0gZWxzZSBpZiAoQXJyYXkuaXNBcnJheShvYmopKSB7XG4gICAgICBmbGF0UmVzdWx0W2Ake3ByZWZpeH1gXSA9IG9iajtcbiAgICB9IGVsc2UgaWYgKHR5cGVvZiBvYmogPT09ICdvYmplY3QnKSB7XG4gICAgICBPYmplY3QuZW50cmllcyhvYmopLmZvckVhY2goKFtrZXksIHZhbHVlXSkgPT4ge1xuICAgICAgICBpZiAodHlwZW9mIHZhbHVlID09PSAnb2JqZWN0Jykge1xuICAgICAgICAgIGZsYXRSZWN1c2l2ZSh2YWx1ZSwgYCR7cHJlZml4fSR7a2V5fS5gKTtcbiAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICBmbGF0UmVzdWx0W2Ake3ByZWZpeH0ke2tleX1gXSA9IHZhbHVlO1xuICAgICAgICB9XG4gICAgICB9KTtcbiAgICB9XG4gIH07XG4gIGZsYXRSZWN1c2l2ZSh0YXJnZXRPYmopO1xuICByZXR1cm4gZmxhdFJlc3VsdDtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IGZsYXRPYmo7XG4iXX0=